__turbopack_context__.v({
  "sketchaiblock": "SketchAIBlock-module-sass-module__iKhy0W__sketchaiblock",
  "sketchaiblock--animated": "SketchAIBlock-module-sass-module__iKhy0W__sketchaiblock--animated",
  "sketchaiblock--editable": "SketchAIBlock-module-sass-module__iKhy0W__sketchaiblock--editable",
  "sketchaiblock--editable__select": "SketchAIBlock-module-sass-module__iKhy0W__sketchaiblock--editable__select",
  "sketchaiblock__animation--in": "SketchAIBlock-module-sass-module__iKhy0W__sketchaiblock__animation--in",
  "sketchaiblock__controls__button": "SketchAIBlock-module-sass-module__iKhy0W__sketchaiblock__controls__button",
  "sketchaiblock__helptext": "SketchAIBlock-module-sass-module__iKhy0W__sketchaiblock__helptext",
  "sketchaiblock__helptext--bottom": "SketchAIBlock-module-sass-module__iKhy0W__sketchaiblock__helptext--bottom",
  "sketchaiblock__iframe": "SketchAIBlock-module-sass-module__iKhy0W__sketchaiblock__iframe",
  "sketchaiblock__loader": "SketchAIBlock-module-sass-module__iKhy0W__sketchaiblock__loader",
  "sketchaiblock__loader--hidden": "SketchAIBlock-module-sass-module__iKhy0W__sketchaiblock__loader--hidden",
});
